module.exports = __webpack_public_path__ + "img/slide-mobile-1.513671a3.jpg";